import type { ComponentType } from 'react';

export const lazyComponent =
  <M, K extends keyof M>(factory: () => Promise<M>, key: K) =>
  () =>
    factory().then((m) => {
      // A chunk can resolve without the export (undefined module on a preloadError reload).
      const Component = m?.[key] as ComponentType | undefined;
      if (!Component) {
        throw new Error(`Lazy chunk is missing export "${String(key)}"`);
      }
      return { Component };
    });
